import { readingPlanConstants } from '../actions/constants/readingPlanConstants';

const initialReadinPlan = {
	items: [],
	detailItems: [],
	error: '',
	isDeleteCompleted: false,
	isFilterAndTotalCountDataLoaded: false,
	status: '',
	message:''
};

const readingPlanData = (state = initialReadinPlan, action: any) => {
	switch (action.type) {
		case readingPlanConstants.ReadingPlanGetByFilterRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};

		case readingPlanConstants.ReadingPlanGetByFilterSucccess:
			if (!state.isFilterAndTotalCountDataLoaded) {
				return {
					...state,
					isLoading: false,
					isSuccess: true,
					isError: false,
					isListSuccess: true,
					isFilterAndTotalCountDataLoaded: true,
					status: action.payload.status,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.readingPlans : [],
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1
				};
			}
			else {
				return {
					...state,
					isLoading: false,
					isSuccess: true,
					isError: false,
					isListSuccess: true,
					status: action.payload.status,
					items: (action.payload !== "" && action.payload !== null) ? action.payload.readingPlans : [],
					totalCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1
				};
			}
		case readingPlanConstants.ReadingPlanGetByFilterFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload
			};

		case readingPlanConstants.ReadingPlanDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isDetailSuccess:false,
				isError: false
			};
		case readingPlanConstants.ReadingPlanDetailSuccess:
			if (!state.isFilterAndTotalCountDataLoaded) {
				return {
					...state,
					isLoading: false,
					isSuccess: action.payload.isSuccess,
					isError: false,
					isListSuccess: true,
					isDetailSuccess: true,
					isFilterAndTotalCountDataLoaded: true,
					status: action.payload.status,
					inputs: action.payload,
					readingPlans:action.payload,
					detailItems: (action.payload !== "" && action.payload !== null) ? action.payload.readingPlanDays : [],
					totalDaysCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1
				};
			}
			else {
				return {
					...state,
					isLoading: false,
					isSuccess: action.payload.isSuccess,
					isError: false,
					isListSuccess: true,
					isDetailSuccess: true,
					status: action.payload.status,
					readingPlans: action.payload,
					detailItems: (action.payload !== "" && action.payload !== null) ? action.payload.readingPlanDays : [],
					totalDaysCount: (action.payload !== "" && action.payload !== null) ? action.payload.totalCount : 1
				};
			}
		case readingPlanConstants.ReadingPlanDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isDetailSuccess: false,
				isError: true,
				status: action.payload,
			};

		case readingPlanConstants.ReadingPlanSaveRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case readingPlanConstants.ReadingPlanSaveSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				status: action.payload.status,
				readingPlanId: action.payload.readingPlanId
			};
		case readingPlanConstants.ReadingPlanSaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case readingPlanConstants.ReadingPlanDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case readingPlanConstants.ReadingPlanDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status,
			};
		case readingPlanConstants.ReadingPlanDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload
			};

		case readingPlanConstants.ReadingPlanDaySaveRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDayValueUpdateComplete: false
			};
		case readingPlanConstants.ReadingPlanDaySaveSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: action.payload.isSuccess,
				isError: false,
				isDayValueUpdateComplete: true,
				status: action.payload.status,
				readingDayResult: action.payload.readingPlanDay
			};
		case readingPlanConstants.ReadingPlanDaySaveFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDayValueUpdateComplete: true,
				status: action.payload
			};

		case readingPlanConstants.ReadingPlanCopyRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case readingPlanConstants.ReadingPlanCopySuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				status: action.payload.status,
			};
		case readingPlanConstants.ReadingPlanCopyFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload
			};

		case readingPlanConstants.ReadingPlanDayDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false
			};
		case readingPlanConstants.ReadingPlanDayDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload.status
			};
		case readingPlanConstants.ReadingPlanDayDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default readingPlanData;
